module.exports = __webpack_public_path__ + "img/img-pickup01.7aaefa19.jpg";